import { useEditor, useNode } from "@craftjs/core";
import * as React from "react";
import { useTranslation } from "react-i18next";
import type { Vendor } from "src/types";

import type { BoothCardProps as CrosbyBoothCardProps } from "@/components/editor/themes/crosby/blocks/expo/booth-card/booth-card-component";
import type { BoothCardProps } from "@/components/editor/themes/starter-hub/blocks/expo/booth-card/booth-card-component";
import { BoothTwoTone } from "@/components/icons/booth-two-tone";
import ImportBase from "@/components/import-list/import-base-component";

type BoothsSettingsProps = {
  template: React.FunctionComponent<BoothCardProps | CrosbyBoothCardProps>;
};

const BoothsSettings = (props: BoothsSettingsProps) => {
  const {
    actions: { addNodeTree },
    query,
  } = useEditor();
  const { t } = useTranslation();

  const { nodeId } = useNode((node) => {
    const nodeId = node
      .getLinkedNodes()
      .find((node) => node.id === "booths-list")?.node.id;
    return {
      nodeId: nodeId || node.id,
    };
  });

  const handleImportVendors = React.useCallback(
    (vendors?: Vendor[]) => {
      if (!nodeId) return;
      if (!vendors.length) return;

      vendors.forEach((vendor) => {
        const element = React.createElement(props.template, { vendor });
        const nodeTree = query.parseReactElementAsNodeTree(element);
        addNodeTree(nodeTree, nodeId);
      });
    },
    [props, query, addNodeTree, nodeId]
  );

  return (
    <ImportBase
      title={t("preference-panel.expo.booths")}
      type="vendors"
      icon={BoothTwoTone}
      importText={t("preference-panel.expo.import-booth-from-event")}
      importButtonText={t("preference-panel.expo.import-booth")}
      onImportClick={handleImportVendors}
      mainEmptyText={t("preference-panel.expo.no-booths-available")}
      subEmptyText={t("preference-panel.expo.add-booth-details")}
      informationText={t("preference-panel.expo.pick-booths-from-event")}
    />
  );
};

export default BoothsSettings;
